import { Component, OnInit, Input} from '@angular/core';
import { CommonService } from '../service/common.service';
import { AbrsystemService } from '../service/abrsystem.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { AViewTextModalComponent } from '../a0106-mail/a-view-text-modal.component';
import { UsersService } from '../service/users.service';
import { Role } from '../app.constant';

@Component({ 
    selector: 'mail-history-app',
    templateUrl: './mail-history.component.html',
    styleUrls: ['mail-history.component.css']
})
export class MailHistoryComponent implements OnInit {
    title : string = 'メール履歴確認';
    isLoaded : boolean = false;
    datalist : any = [];
    all_datalist : any = [];
    queuelist:any=[];
    ROLE: any = Role;
    page : number = 1;
    all_count:number=0;
    display_per_page:  number = 20;   /* 最大表示件数 */
    selectid:any=0;
    mode:number;

    constructor(
        private commonService: CommonService,
        private abrsystemservice: AbrsystemService,
        public usersService: UsersService,
        private modalService: NgbModal,
        private router: Router,
        private route: ActivatedRoute,
        private location: Location,
    ) { }
    ngOnInit(): void {
        this.mode = +this.route.snapshot.paramMap.get('mode');
        this.getList();
        this.selectid = 0;
    };
    clearData (): void{
        this.isLoaded = false;
        this.datalist = [];
        this.all_datalist = [];
        this.queuelist = [];
    }
    getList(): void {
        this.clearData();
        this.abrsystemservice.getMailHistoryList(this.mode)
        .subscribe((res: Response) => {
            if (res["fuel_status"] == "OK") {
                this.queuelist= res["fuel_results"]['busy_list'];
                this.all_datalist = res["fuel_results"]['cotract_company_list']['cotract_company'];
                if (this.all_datalist.length > 0) {
                    this.select_contract_company(this.selectid);
                    this.page = 1;
                    this.changePage(1);
                }
                this.isLoaded = true;
            }else if (res["fuel_status"] == "NG") {
                this.commonService.modalOpens(res["fuel_message"],modalresult=>{});
            }else{
                this.commonService.modalOpens(11003,modalresult=>{});
            }
        },error => {
            this.commonService.modalOpens(error,modalresult=>{});
        });
    }
    select_contract_company(i){
        this.selectid=i;
        this.all_count = this.all_datalist[this.selectid]['history'].length;
        this.page = 1;
        this.changePage(1);
    }

    changePage(e){
        var start = (e-1)*this.display_per_page;
        this.datalist = this.all_datalist[this.selectid]['history'].slice(start, start+this.display_per_page);
    }
    reload(): void {
        this.getList();
    };
    showerror(row) : void {
        const modalRef = this.modalService.open(
            AViewTextModalComponent,//対象のComponent
            { backdrop: 'static', keyboard: false,size: 'lg' }//オプション設定　Esc,背景クリックの時の処理…停止中
        );

        let sendlisttext :string = "";

        modalRef.componentInstance.view_title = 'エラー';
        modalRef.componentInstance.view_text = row.send_result;
        modalRef.result.then(
            result => {
                if(result.status=='Cancel'){
                    //Cancel時の処理
                }else{
                    
                }
            }, function () {
            // Esc,背景クリックの時の処理…オプション設定で停止中
            }
        );
    }
    delhistory(row):void{
        this.commonService.modalOpens(50002,
            //削除してもよろしいですか？
            modalresult => {
                if (modalresult == "OK") {
                    this.abrsystemservice.deleteMailHistory(row)
                        .subscribe((res: Response) => {
                            if (res["fuel_status"] == "OK") {
                                this.commonService.modalOpens(10002, modalresult => {
                                    this.getList();
                                });
                            }else if (res["fuel_status"] == "NG") {
                                this.commonService.modalOpens(res["fuel_message"],modalresult=>{});
                            }else{
                                this.commonService.modalOpens(11003,modalresult=>{});
                            }
                        },error => {
                            this.commonService.modalOpens(error,modalresult=>{});
                        });
                } else {
                    //
                }
            }
        );
    }
    mailcontentsOpen(row:any) : void {
        const modalRef = this.modalService.open(
            AViewTextModalComponent,//対象のComponent
            { backdrop: 'static', keyboard: false,size: 'lg' }//オプション設定　Esc,背景クリックの時の処理…停止中
        );
        modalRef.componentInstance.view_title = row.mail_subject;
        modalRef.componentInstance.view_text = row.mail_body;
        modalRef.result.then(
            result => {
                if(result.status=='Cancel'){
                    //Cancel時の処理
                }else{
                    
                }
            }, function () {
            // Esc,背景クリックの時の処理…オプション設定で停止中
            }
        );
    }
    sendlistOpen(row:any) : void {
        const modalRef = this.modalService.open(
            AViewTextModalComponent,//対象のComponent
            { backdrop: 'static', keyboard: false,size: 'lg' }//オプション設定　Esc,背景クリックの時の処理…停止中
        );

        let sendlisttext :string = "";
        
        modalRef.componentInstance.view_title = row.mail_subject;
        if (row["send_mode"]=="person"){
            sendlisttext = "全"+row.personlist.length + "件送信<br>";
            for (let i = 0; i < row.personlist.length; i++) {
                sendlisttext += row.personlist[i]['t_company_name']+"："+row.personlist[i]['t_person_name'];
                if (row.personlist[i]['resulted'] == "1"){
                    sendlisttext += "<span class='badge badge-danger'>送信失敗</span>";
                }
                sendlisttext += " < " + row.personlist[i]['t_send_mail_distination_mail'] + " > " + "<br>";
            }
        }else if (row["send_mode"]=="syozoku"){
            sendlisttext = "全"+row.personlist.length + "件送信<br>";
            for (let i = 0; i < row.personlist.length; i++) {
                sendlisttext += row.personlist[i]['t_company_name']+"："+row.personlist[i]['t_syozoku_name']+"："+row.personlist[i]['t_person_name'];
                if (row.personlist[i]['resulted'] == "1"){
                    sendlisttext += "<span class='badge badge-danger'>送信失敗</span>";
                }
                sendlisttext += " < " + row.personlist[i]['t_send_mail_distination_mail'] + " > " + "<br>";
            }
        }else if (row["send_mode"]=="company"){
            sendlisttext = "全"+row.personlist.length + "件送信<br>";
            for (let i = 0; i < row.personlist.length; i++) {
                sendlisttext += row.personlist[i]['t_company_name']+"："+row.personlist[i]['t_person_name'];
                if (row.personlist[i]['resulted'] == "1"){
                    sendlisttext += "<span class='badge badge-danger'>送信失敗</span>";
                }
                sendlisttext += " < " + row.personlist[i]['t_send_mail_distination_mail'] + " > " + "<br>";
            }
        }



        modalRef.componentInstance.view_text = sendlisttext;
        modalRef.result.then(
            result => {
                if(result.status=='Cancel'){
                    //Cancel時の処理
                }else{
                    
                }
            }, function () {
            // Esc,背景クリックの時の処理…オプション設定で停止中
            }
        );
    }
    goBack(): void {
        this.location.back();
    }
}



// WEBPACK FOOTER //
// ./src/app/a0116-mail-history/mail-history.component.ts